import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { tabValueAtom } from '_state/signature';
import EmailPreview from './email/emailPreview';
import MeetingBackground from './meeting/meetingBackground';
import MeetingPreview from './meeting/meetingPreview';

const SignaturePreview = () => {
  const tableValue = useRecoilValue(tabValueAtom);

  const emailSignature = tableValue === 'Email Signature';

  return (
    <div className="signaturePreview px-4">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <Box
              sx={
                !emailSignature ? { border: 'none !important', borderRadius: '0 !important' } : {}
              }
              className="signaturegenrator"
            >
              {emailSignature ? (
                <EmailPreview />
              ) : (
                <>
                  <MeetingPreview />
                  <MeetingBackground />
                </>
              )}
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignaturePreview;
